import React, { useState, useEffect, useRef } from 'react';
import $ from "jquery";

import { getPlatformIcon } from "../../util";
import Select from "./select";

interface Props {
    onDownload: (url?: string) => void;
    items: any[];
};

const Download = (props: Props) => {
    const { items, onDownload } = props;
    const [ showSelect, setShowSelect ] = useState(false);
    const node: any = useRef(null);

    const onClick = (e: any) => {
	if (!items) {
	    onDownload();
	} else
	if (items.length == 1) {
	    onDownload(items[0]);
	} else {
	    setShowSelect(!showSelect);
	};
    };

    const onSelect = (item: any) => {
	onDownload(item);
	setShowSelect(false);
    };

    useEffect(() => {
	$('body').on('click', (e) => {
	    if (!node.current.contains(e.target) && showSelect) {
		setShowSelect(false);
	    };
	});
    }, [ showSelect ]);

    return (
	<div ref={node} className={[ 'download', showSelect ? 'showSelect' : '' ].join(' ')}>
	    <div className="button noselect" onClick={onClick}>
		<div className={[ 'icon', getPlatformIcon() ].join(' ')} />
		<span>Download</span>
	    </div>

	    <Select onSelect={onSelect} items={items} />
	</div>
    );
};

export default Download;